<template>
<span>
    <button class="btn" @click="show = !show">
        <i class="material-icons left">settings</i>
        Автоудаление {{getAuthUserData.notificationsAutoDelete && '[ВКЛ]'}}
    </button>
    <div class="card" v-show="show">
        <div class="card-content">
            <span class="card-title">Настройка автоудаления уведомлений</span>
            <div class="input-field">
                <select v-model="notificationsAutodeleteValue" ref="notificationsAutodeleteSelect">
                    <option :value="undefined">Отключено</option>
                    <option :value="5">Удалять уведомления старше 5 дней</option>
                    <option :value="30">Удалять уведомления старше 30 дней</option>
                </select>
            </div>
            <button class="btn" @click="setAutoDelete()">Установить</button>
        </div>
    </div>
</span>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    data(){
        return{
            notificationsAutodeleteValue: undefined,
            show: false
        }
    },
    computed: {
        ...mapGetters(['getAuthUserData'])
    },
    methods:{
        async setAutoDelete(){
            const res = (await this.$axios.put('/changeAuthUserProfile/notificationsAutoDelete', {
                notificationsAutoDelete: this.notificationsAutodeleteValue
            })).data

            if(res) this.$router.go()
        }
    },
    mounted(){

        this.notificationsAutodeleteValue = this.getAuthUserData.notificationsAutoDelete

        this.$nextTick(()=>{
            M.FormSelect.init(this.$refs.notificationsAutodeleteSelect);
        })

    }
}
</script>